"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// modulo (%) for non integer numbers 
var mod = function mod(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
};

exports.mod = mod;